import { getCurrentInstance } from '@vue/composition-api';

export const useRoute = () => {
    const vm = getCurrentInstance();
    return vm.proxy.$route;
  }

export const useRouter = () => {
    const vm = getCurrentInstance();
    return vm.proxy.$router;
}

export const useStore = () => {
    const vm = getCurrentInstance();
    return vm.proxy.$store;
}
